import { tgxApi } from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess,
} from "../../../helpers/utils/RtkQueryUtils";
import { getFileName, serialize } from "../../../helpers/utils/Utils";
import { downloadFile } from "../../../helpers/utils/FileUtils";

export const managementCompanyApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchManagementCompanyApi: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/ManagementCompanies?${paramData}`,
                    method: 'POST',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['managementCompanies'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getManagementCompanyById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-management-company-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['managementCompaniesById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getManagementCompanyNotesByCompanyId: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-management-company-notes-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['managementCompanyNotesById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getContactById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-contact/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['contactById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getSubdivisionByCompanyId: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/get-subdivision-by-association/management-company?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },

            providesTags: ['managementCompanySubdivision'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        updateManagementCompanyDetailApi: build.mutation({
            query: ({ requestBody, companyId }) => {
                return {
                    url: `/ajax/update/management-company/${companyId}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['managementCompaniesById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Management Company");
            },
        }),
        createManagementCompanyApi: build.mutation({
            query: (requestBody) => {

                return {
                    url: `/ajax/create/management-company`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['managementCompanies'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Management Company");
            },
        }),
        deleteManagementCompanyNoteById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-management-company-note-by-id/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['managementCompanyNotesById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Management Company Note");
            },
        }),


        deleteManagementCompanyById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-mgtm-company-by-id/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags:["managementCompanies"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Management Company");
            },
        }),
        exportManagementCompanyData: build.query({
            query: (query) => {
                return {
                    url: `/export/management-company?`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("management companies"))
                        return { success: true };
                    },
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        createManagementNotesApi: build.mutation({
            query: ({id,obj}) => {
                return {
                    url: `/ajax/create-management-company-note/${id}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: obj
                };
            },
            invalidatesTags: ['managementCompanies',"certificateNotesById","managementCompanyNotesById"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Management Company Note");
            },
        }),
    }),
});


export const {
    useGetManagementCompanyByIdQuery,
    useLazyExportManagementCompanyDataQuery,
    useSearchManagementCompanyApiQuery,
    useGetManagementCompanyNotesByCompanyIdQuery,
    useGetSubdivisionByCompanyIdQuery,
    useUpdateManagementCompanyDetailApiMutation,
    useDeleteManagementCompanyNoteByIdMutation,
    useCreateManagementCompanyApiMutation,
    useGetContactByIdQuery,
    useDeleteManagementCompanyByIdMutation,
    useCreateManagementNotesApiMutation
} = managementCompanyApi;